import { Link } from "react-router-dom";
import BrandLogo from "@/components/BrandLogo";
import { ShieldCheck, HeartStraight } from "@phosphor-icons/react";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 mt-16 relative overflow-hidden">
      <div className="mx-auto max-w-6xl px-5 md:px-8 py-10 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <BrandLogo size={38} showWordmark withSubline />
          <p className="mt-4 text-sm text-neutral-500 max-w-xs leading-relaxed">
            LeLe helps you document informal loans between people who trust each
            other — with clarity, dignity, and legal weight.
          </p>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.25em] text-neutral-500 mb-3">
            Company
          </div>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/about" data-testid="footer-about-link" className="text-neutral-300 hover:text-neutral-100">
                About LeLe
              </Link>
            </li>
            <li>
              <Link to="/support" data-testid="footer-support-link" className="text-neutral-300 hover:text-neutral-100">
                Support · Need help?
              </Link>
            </li>
            <li>
              <Link to="/terms" data-testid="footer-terms-link" className="text-neutral-300 hover:text-neutral-100">
                Terms &amp; conditions
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.25em] text-neutral-500 mb-3">
            Our promise
          </div>
          <div className="flex items-start gap-2 text-sm text-neutral-300 mb-3">
            <ShieldCheck size={16} weight="duotone" className="text-indigo-400 mt-0.5 shrink-0" />
            <span>Protect every rupee.</span>
          </div>
          <div className="flex items-start gap-2 text-sm text-neutral-300">
            <HeartStraight size={16} weight="duotone" className="text-fuchsia-400 mt-0.5 shrink-0" />
            <span>Preserve every relationship.</span>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5 py-5 text-center text-[11px] uppercase tracking-[0.3em] text-neutral-600">
        © {new Date().getFullYear()} LeLe · Let's LeLe.
      </div>
    </footer>
  );
}
